//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['receipt'],
  data() {
    return {}
  },
  computed: {
    successful() {
      return this.processingStatus == 'completed'
    },
    completed() {
      return this.processingStatus == 'completed'
    },
    showResults() {
      return this.processingStatus == 'completed'
      return false
    },
    processingStatus: {
      get() {
        return this.$store.state.betbuilder.processingStatus
      },
      set(value) {
        this.$store.commit('betbuilder/setProcessingStatus', value)
      }
    }
  },
  mounted() {},
  methods: {
    onClickOutside(event) {
      console.log('Clicked outside. Event: ', this.successful, event)
      if (this.successful && !this.$device.isMobile) {
        // this.close();
      }
    },
    async close() {
      this.$emit('close')
    },
    async clear() {
      this.$emit('close')
      this.$store.commit('betbuilder/clear')
      this.$store.commit('betbuilder/clearStakes')
      this.$store.commit('betsbetbuilderlip/setBetType', 'single')
      this.$store.commit('betbuilder/setStakeSingle', null)
      this.$store.commit('betbuilder/setStakeCombi', null)

      this.$store.commit('betbuilder/toggleBetslip', false)
    }
  }
}
